export default function initCarousel() {
  document.querySelectorAll(".carousel").forEach((carousel) => {
    const slides = carousel.querySelectorAll(".carousel-slide");
    const thumbs = carousel.querySelectorAll(".carousel-thumb");
    const main = carousel.querySelector(".carousel-main__image");
    const thumbsContainer = carousel.querySelector(".carousel-thumbs");

    if (!slides.length) return;

    let currentIndex = 0;

    function showSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      main.style.transform = `translateX(-${currentIndex * 100}%)`;

      slides.forEach((slide, i) => {
        slide.classList.toggle("is-active", i === currentIndex);
      });

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle("is-active", i === currentIndex);
      });

      scrollThumbIntoView(currentIndex);
    }

    function scrollThumbIntoView(index) {
      if (!thumbsContainer || !thumbs[index]) return;

      const container = thumbsContainer;
      const thumb = thumbs[index];

      const containerRect = container.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();

      const thumbLeft =
        thumbRect.left - containerRect.left + container.scrollLeft;
      const thumbRight = thumbLeft + thumb.offsetWidth;

      const containerLeft = container.scrollLeft;
      const containerRight = containerLeft + container.clientWidth;

      if (thumbLeft < containerLeft) {
        container.scrollTo({ left: thumbLeft, behavior: "smooth" });
      } else if (thumbRight > containerRight) {
        container.scrollTo({
          left: thumbRight - container.clientWidth,
          behavior: "smooth",
        });
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        showSlide(Number(thumb.dataset.index));
      });
    });

    const prevBtn = carousel.querySelector(".carousel-arrow--prev");
    const nextBtn = carousel.querySelector(".carousel-arrow--next");

    prevBtn?.addEventListener("click", () => showSlide(currentIndex - 1));
    nextBtn?.addEventListener("click", () => showSlide(currentIndex + 1));

    // スワイプ対応（追従あり）
    const frame = carousel.querySelector(".carousel-main__frame");
    let touchStartX = 0;
    let currentTranslate = 0;
    const SWIPE_THRESHOLD = 40;

    frame.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.touches[0].clientX;
        currentTranslate = currentIndex * 100; // 現在位置を%で保持

        // 追従中はtransitionを切る
        main.style.transition = "none";
      },
      { passive: true },
    );

    frame.addEventListener(
      "touchmove",
      (e) => {
        const diff = touchStartX - e.touches[0].clientX;
        const diffPercent = (diff / frame.offsetWidth) * 100;

        main.style.transform = `translateX(-${
          currentTranslate + diffPercent
        }%)`;
      },
      { passive: true },
    );

    frame.addEventListener(
      "touchend",
      (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;

        // transitionを戻す
        main.style.transition = "transform 0.4s ease";

        if (Math.abs(diff) < SWIPE_THRESHOLD) {
          // 閾値未満 → 元の位置に戻す
          main.style.transform = `translateX(-${currentIndex * 100}%)`;
          return;
        }

        diff > 0 ? showSlide(currentIndex + 1) : showSlide(currentIndex - 1);
      },
      { passive: true },
    );

    showSlide(0);
  });
}
